import React, { useRef } from "react";
import { Box } from "@mui/material";
import NeoButton from "./NeoButton"; // adjust path as needed
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { MainContext } from "../App";

const HorizontalScrollContainer = ({ children }) => {
  const scrollRef = useRef();
  const { Theme } = React.useContext(MainContext);

  const scroll = (dir) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.clientWidth * 0.8;
      scrollRef.current.scrollBy({
        left: dir === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        containerType: "inline-size",
      }}
    >
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: -30,
          zIndex: 10,
          transform: "translateY(-50%)",
        }}
      >
        <NeoButton
          color={Theme.palette.primary.main}
          isIcon
          icon={<ChevronLeft />}
          onClick={() => scroll("left")}
        />
      </Box>
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "scroll",
          scrollBehavior: "smooth",
          scrollSnapType: "x mandatory",
          gap: 2,
          //   px: 5,
          scrollbarWidth: "none",
          height: "100%",
          width: "100%",
          "& > *": {
            flexShrink: 0, // Prevent shrinking
          },
        }}
      >
        {children}
      </Box>
      <Box
        style={{
          position: "absolute",
          top: "50%",
          right: -30,
          zIndex: 10,
          transform: "translateY(-50%)",
        }}
      >
        <NeoButton
          color={Theme.palette.primary.main}
          isIcon
          icon={<ChevronRight />}
          onClick={() => scroll("right")}
        />
      </Box>
    </Box>
  );
};

export default HorizontalScrollContainer;
